module.exports = __webpack_public_path__ + "media/images/book-img-01-23bd0b2a0e5554803fc56cb114b80a1e.png";